module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/85288751058f7704ffdb91f15d189260.svg";